jQuery(function ($) {
  const scrollAdjust = '#header' // スムーズスクロールの補正要素
  // const scrollAdjust = 0  //スムーズスクロールの補正要素
  $('.js-move')
    .not('.no-move , [target="_blank"]')
    .on('click', function () {
      // アンカーをクリックしたらスクロール
      let href = $(this)
        .attr('data-move')
        .replace(/.*#/gi, '#') // 同一ページならハッシュ以外を削ってページ遷移を抑止
      autoScroll(href, scrollAdjust)
    })
  if (location.hash) autoScroll(location.hash, scrollAdjust, false) // アクセス時にハッシュがある場合はスクロール
  // スクロール処理 point:目標地点 adjust:位置をずらす場合の基準要素or基準値 anime：アニメーションの有無
  function autoScroll (point, adjust, anime) {
    if (adjust === undefined) {
      // 未定義なら0
      adjust = 0
    } else if (isNaN(adjust)) {
      // 数値以外でなら要素として高さ取得
      adjust = $(adjust).outerHeight()
    }
    let target = $(point === '#' || point === '' ? 'html' : point)
    if ($(target)[0]) {
      // ターゲットを検出したら実行
      if (anime === true || anime === undefined) {
        // 未定義ならアニメーションさせる
        $('html , body')
          .not(':animated')
          .animate(
            {
              scrollTop: target.offset().top - adjust
            },
            500,
            'swing'
          )
      } else {
        $('html , body').not(':animated').animate({scrollTop: target.offset().top - adjust}, 10, 'linear')
      }
    }
    return false
  }
})
